import React from 'react';
import classnames from 'classnames';
class BaseFooter extends React.Component {
    /* 固定的页脚，可配置，比如此刻，今日，确定什么的.. 其次，扩展的页脚由上层传入render回调即可*/
    render() {
        const {
            functions,
            onChange,
            onSelect,
            renderExtraFooter,
            picker,
            locale,
            functionValue,
            showToday,
            otherPickerProps,
        } = this.props;
        return <>
            {/* 日期函数 */}
            <div style={{ whiteSpace: 'normal' }}>
                {functions && Object.entries(functions).filter(([, { hide }]) => !hide).length > 0 && Object.keys(functions).length > 0 && <div className="date-functions">
                    {Object.entries(functions).filter(([, { hide }]) => !hide).map(([functionName, { name, type }]) => {
                        return <span
                            key={functionName}
                            className={classnames({ active: Array.isArray(functionValue) ? functionValue.some(value => value === functionName) : functionValue === functionName })}
                            onClick={() => {
                                onSelect?.(functionName, 'date');
                                if (type === picker || picker !== 'dateTime') {
                                    onChange?.(functionName);
                                }
                            }}
                        >
                            {name}
                        </span>;
                    })}
                </div>}
            </div>
            {/* 额外页脚 */}
            {renderExtraFooter && <div className="picker-panel-extra-footer">
                {renderExtraFooter()}
            </div>}
            {(picker === 'dateTime' || (showToday && picker === 'date') || picker === 'time') &&
                <div className="picker-panel-footer">
                    {/* 今日按钮 */}
                    <button
                        onClick={() => {
                            onSelect(new Date());
                            onChange();
                        }}
                        className={classnames({ 'today-hidden': !showToday || picker !== 'date' && picker !== 'dateTime' })}
                    >
                        {/* 今日 */}
                        {locale['0003']}
                    </button>
                    {/* 确定按钮 */}
                    {(picker === 'dateTime' || picker === 'time') &&
                        <button
                            onClick={() => {
                                onChange();
                            }}
                            className='ok-btn'
                            {...otherPickerProps?.okBtn}
                        >
                            {/* 确定 */}
                            {locale['0024']}
                        </button>}
                </div>}
        </>;
    }
}

export default BaseFooter;